import axios from "axios";
import {GET_USER_LIKES, RESET_USER_LIKES, LOADING} from "../actionTypes";
import {customerToken} from "helper";
import {adminToken} from "../../helper";

const {SET_TRUE, SET_FALSE} = LOADING;

export const get = ({countryCode, mobile}) => {
    return async dispatch => {
        if (!countryCode || !mobile) return;

        dispatch({type: SET_TRUE});

        try {
            // const token = await adminToken();

            const token = await customerToken({mobile, countryCode});

            // http://cgapp.clykk.com:8091/api/v2/user/packagelike
            // https://cgapp.clykk.com/like/api/v2/user/packageLike

            const {data} = await axios.get(`https://cgapp.clykk.com/like/api/v2/user/packageLike`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            dispatch({type: GET_USER_LIKES, payload: data?.rs});
        } catch (err) {
            console.log(err);
        } finally {
            dispatch({type: SET_FALSE});
        }
    };
};

export const reset = () => dispatch => dispatch({type: RESET_USER_LIKES});
